import * as React from 'react';
import * as Header from '../constants/Header';
import * as PropTypes from 'prop-types';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/settings.css';

import ChangePasswordForm from '../containers/ChangePasswordForm';

class DoneChangePassword extends React.Component {
  render() {
    return (
      <div>
        <div id="result" className="changePassword">
          <h2>パスワードを変更しました。</h2>
        </div>
      </div>
    );
  }
}

interface ChangePasswordProps extends React.Props<{}> {
  headerActions?: any;
  password: any;
  passwordActions: any;
}

class ChangePassword extends React.Component<ChangePasswordProps, {}> {
  static propTypes = {
    password: PropTypes.any.isRequired,
    passwordActions: PropTypes.any.isRequired,
  };

  constructor (props: any) {
    super(props);
  }

  componentWillMount() {
    document.title = '管理';
    this.props.headerActions.setPage(Header.SETTING_CHANGE_PASSWORD);
    this.props.passwordActions.resetStatus();
  }

  render() {
    return (
      <div>
        {
          (() => {
            if (this.props.password.Loaded) {
              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        {(this.props.password.Loaded) ? (
          (this.props.password.result) ?
            <DoneChangePassword key="message" /> : <ChangePasswordForm key="form" />
          ) :
            (null)
        }
      </div>
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/ChangePassword.tsx